<svg
	class={$$props.class}
	xmlns="http://www.w3.org/2000/svg"
	width="24"
	height="24"
	viewBox="0 0 24 24"
	><path
		fill="currentColor"
		d="M17.77 3.77L16 2L6 12l10 10l1.77-1.77L9.54 12z"
	/></svg
>
